import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import InsertBodyContent from './InsertBodyContent';

export default function CasinoInsertBody() {
  return (
    <CasinoContainer title={'HTML before </body> for casino'}>
      <InsertBodyContent />
    </CasinoContainer>
  );
}
